// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n0-6";
export var imgContainer = "_n0-3";
export var menuIcon = "_n0-5";
export var pillWrapper = "_n0-2";
export var pillsContainer = "_n0-1";
export var subscriptionCard = "_n0-0";
export var subscriptionLogo = "_n0-4";